import React from 'react';
import { defineMessages, useIntl, type MessageDescriptor } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import TextReviewIcon from '@atlaskit/icon-lab/core/text-review';

import { useAIRovoButtonEnablement } from '@confluence/ai-common/entry-points/useAIRovoButtonEnablement.ts';

export const reviewButtonMessages: { reviewSuggestionsLabel: MessageDescriptor } = defineMessages({
	reviewSuggestionsLabel: {
		id: 'object-sidebar-components.review-suggestions.button.label',
		defaultMessage: 'Review suggestions',
		description:
			'Tooltip and accessible label for the review icon button in the object sidebar that opens AI suggested edits for the page',
	},
});

// Kept apart from ReviewButton so the loader's placeholder and the lazily loaded button render the
// same icon button without the placeholder importing the button's implementation.
export const ReviewButtonBase = (
	props: Omit<
		React.ComponentProps<typeof IconButton>,
		'icon' | 'label' | 'appearance' | 'shape' | 'testId'
	>,
): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const isRovoButtonEnabled = useAIRovoButtonEnablement();
	return (
		<IconButton
			{...props}
			icon={TextReviewIcon}
			appearance="subtle"
			label={formatMessage(reviewButtonMessages.reviewSuggestionsLabel)}
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			testId="object-sidebar-review-button"
		/>
	);
};
